import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, Input, model, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { FloatLabelModule } from 'primeng/floatlabel';
import { ɵɵDir } from "@angular/cdk/scrolling";


@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
  imports: [CommonModule, FormsModule, MultiSelectModule, DropdownModule, SelectModule, FloatLabelModule],
  standalone: true,
})
export class DropdownComponent {
  showPanel = false;
  option = model<any>();
  @Input() options: any[] = [];
  @Input() propiedad!: string;
  @Input() filtrar!: boolean;
  @Input() limpiar!: boolean;
  @Input() etiqueta = 'Inserte etiqueta';
  @Input() placeholder = 'Inserte placeholder';
  @Input() id = '';
  @Input() descripcionLabel!: string | null;
  @Input() setFirstValue = true;
  @Input() readonly = false;
  @Input() disabled!: boolean;

  @ViewChild('dropdown') dropdown!: Dropdown;

  ngAfterViewInit() {
    if (this.setFirstValue) this.option.set(this.options[0]);
  }

  @Input() multiple = false;

  /** Permite linkear una variable bool, para mostrar los mensajes de error, desaparece si el usuario
   * ingresa el valor */
  @Input() showError = false;
  @Input() mensajeError = '';
}
